import { useState, useEffect } from 'react';
import { fetchFilterConfig } from '../services/authService';
import { getStoredUser } from '../utils/auth';

/**
 * useRbacFilters
 * Fetches the RBAC filter configuration for the logged-in user.
 * Returns what the filter panel should show/hide and what data is scoped.
 */
export function useRbacFilters() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const data = await fetchFilterConfig();
        setConfig(data);
      } catch {
        // Fallback — superadmin-level access if API fails
        const user = getStoredUser();
        setConfig({
          role:                   user?.role || 'superadmin',
          showDateOfDataLock:     true,
          showLastDateOfFollowUp: true,
          showGeographicRegions:  true,
          showHospitals:          true,
          showPhysicians:         true,
          maxTimepointMonths:     null,
          allowedZones:           null,
          allowedHospitals:       null,
          singleHospitalMode:     false,
        });
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { config, loading };
}
